module.exports = __webpack_public_path__ + "static/img/03.a8af022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/03.png
// module id = W1wG
// module chunks = 1